'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadByThreadId = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

var _getThreads = require('./getThreads');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var threadIdFromProps = function threadIdFromProps(state, _ref) {
  var threadId = _ref.threadId;

  return threadId;
};

var getThreadByThreadId = exports.getThreadByThreadId = (0, _reselect.createSelector)([_getThreads.getThreads, threadIdFromProps], function (threadsData, threadId) {
  return (0, _get2.default)(threadId, threadsData);
});